/**
 * 应用入口文件（学校端）
 * 初始化 Vue 实例，挂载路由和状态管理
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// 加载全局插件配置（ElementUI、axios、权限控制、过滤器等）
import './config/plugins';
// IE浏览器兼容性 polyfill
import 'babel-polyfill';

// 关闭生产环境 Vue 提示
Vue.config.productionTip = false;

// 创建 Vue 根实例
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
